import { Typography } from '@mui/material';
import { DynamicIcon, PartnerTimeZoneTooltip } from 'src/components';
import { MessageTimestamp } from 'src/pages/Conversations/Chat/ChatMessage/chat-message';

export const ChatInfoWithTimestamp = ({
  message,
  date,
  partnerId,
  color,
  icon,
}: {
  icon: string;
  message: string;
  date: string;
  partnerId: number;
  color?: string;
}) => {
  return (
    <>
      <DynamicIcon name={icon} />
      <MessageTimestamp className="timestamp">
        <PartnerTimeZoneTooltip date={date} partnerId={partnerId}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              textWrap: 'wrap',
              color,
            }}
          >
            {message}
          </Typography>
        </PartnerTimeZoneTooltip>
      </MessageTimestamp>
    </>
  );
};
